import React from "react";
import SurveyComponent from '../../components/SurveyComponent/SurveyComponent'

const Surveys = () => {
    return (
        <div className="surveys-container">
            <div>
                <SurveyComponent />
            </div>

        </div>
    );
};

export default Surveys;